"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hollandTranslations = void 0;
var _types = require("../../../types");
const hollandTranslations = exports.hollandTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Het spijt ons!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Terug',
  [_types.ErrorPageTranslationKey.text]: 'Deze pagina werkt momenteel niet',
  [_types.ErrorPageTranslationKey.notFound]: 'De pagina die je probeert te bereiken lijkt niet te werken',
  [_types.ErrorPageTranslationKey.unauthorized]: 'De pagina die je probeert te bereiken is beperkt bereikbaar en je voldoet niet aan alle criteria.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Neem per e-mail contact op met het Oriflame-ondersteuningsteam:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'De opgevraagde URL is afgewezen!'
};
